import {
  TextWrapper,
  Wrapper,
  CircleImage,
  Form, StyledButton
} from "./styles";
import { Text } from "components/Text";
import { useNativeLogin } from "hooks/login/useLogin.hook";
import { Flex } from "antd";
import { PodoUpLogotyp11Color } from "assets/icons";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Input } from "components/Input";
import { useEffect, useRef } from "react";
import { useOneTimeLogin } from "hooks/login/useOneTimeLogin.hook";
import { useMobileTransferLogin } from "hooks/login/useMobileTransferLogin.hook";
import { REACT_APP_LOGO, REACT_TITLE } from "config/env";
import { getIsZenPilatesApp } from "helpers/is-zen-pilates-app.helper";
import spacing from "theme/spacing.module.scss";

const LoginView = () => {
  const [params] = useSearchParams();
  const location = useLocation();
  const phone = location.state?.phone;
  const login = location.state?.login;
  const redirectTo = location.state?.redirectTo;
  const { onOneTimeAuth } = useOneTimeLogin();
  const { onMobileTransferAuth } = useMobileTransferLogin();
  const {
      onSubmit,
      loginError,
      loading,
      control,
      setValue,
      isValid
  } = useNativeLogin();

  const oneTimeAuthTriggered = useRef(false);
  useEffect(() => {
    const token = params.get("token");
    if (!token || oneTimeAuthTriggered.current) return;
    oneTimeAuthTriggered.current = true;
    onOneTimeAuth({ token });
  }, [params]);

  // kod jest jednorazowy - zabezpieczenie przed powtórnym wywołaniem (np. React StrictMode
  // podwójnie odpalający efekty w dev), które trafiłoby na już zużyty link
  const mobileTransferAuthTriggered = useRef(false);
  useEffect(() => {
    const transferCode = params.get("transferCode");
    if (!transferCode || mobileTransferAuthTriggered.current) return;
    mobileTransferAuthTriggered.current = true;
    onMobileTransferAuth({ code: transferCode });
  }, [params]);

  useEffect(() => {
    if (phone) {
      setValue("login", phone);
    }
    if (login) {
      setValue("login", login);
    }
  }, [phone, login]);

  return (
    <Wrapper>
      <TextWrapper>
        {REACT_APP_LOGO ? (
          <img src={REACT_APP_LOGO} alt="logo" className="main-logo" />
        ) : (
          <PodoUpLogotyp11Color className="main-logo" />
        )}
        <Text $textVariant="pBold">Zaloguj się,</Text>
        <Text $textVariant="pBold">aby korzystać z</Text>
        <Text $textVariant="pBold">{REACT_TITLE}</Text>
        <CircleImage />
      </TextWrapper>
      <Form>
        <Input
          placeholder="Login *"
          name="login"
          control={control}
          type="text"
          value={phone}
        />
        <Input
          placeholder="Hasło *"
          name="password"
          control={control}
          type="password"
        />
        <Flex vertical>
            <Flex gap={spacing.spacingSM} justify="space-between">
                <Link to="/change-password-modal">Nie pamietasz hasła?</Link>
                {getIsZenPilatesApp() &&
                    <Link to="/register" state={{ redirectTo }}>Zarejestruj się</Link>
                }
            </Flex>
          {loginError && <Text $textColor="accentRed500">{loginError}</Text>}
          <StyledButton
            onClick={onSubmit}
            size="large"
            type="primary"
            disabled={!isValid}
            loading={loading}
          >
            Zaloguj się
          </StyledButton>
        </Flex>
      </Form>
    </Wrapper>
  );
};
export default LoginView;
